module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921092651_T.8f53fe49.jpg";